// Shared chip styling for the dashboard's two segmented controls — the view
// tabs and the date-range presets. They sit on the same header row, so they
// must be the same object rather than two things that merely look alike.
//
// Deliberately not ui-components/CustomTabs: that renders 1.1rem/700 labels
// with 2rem padding, which would make the tab bar the largest element on a
// page whose whole point is to put the weight on the numbers. It also needs a
// TabContext parent.
import { T } from "utils/backrrTokens";

export const segmentChipSx = (theme, active) => ({
  minWidth: 0,
  padding: "3px 10px",
  fontSize: "0.75rem",
  fontWeight: 600,
  lineHeight: 1.6,
  textTransform: "none",
  borderRadius: "6px",
  border: `1px solid ${active ? T.accent : T.border}`,
  color: active ? T.accent : T.inkMuted,
  backgroundColor: active ? T.accentSoft : T.surface,
  "&:hover": {
    backgroundColor: active ? T.accentSoft : T.grid,
    borderColor: T.accent,
  },
  "&:focus-visible": {
    outline: `2px solid ${T.accent}`,
    outlineOffset: "1px",
  },
});
